<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <button v-show="pageShowData" v-on:click="onPrintButtonClick" type="button" class="btn btn-warning" style="float:right">
        Print
      </button>

      <h3 id="title2">{{ 'PASSCARD TO PARKAIDE APPLICATION ' + (pageApplicationNum || '') }}</h3>

      <hr>

      <div 
        v-show="pageShowData"
        class="row"
        style="padding-left: 30px; padding-right: 30px">

        <AppForm
          ref="pageForm" 
          v-bind:formParameter="PARAM"
          v-bind:permission="permission"
          class="col">

        </AppForm>

        <div
          v-show="pageShowExtra"
          class="col-auto"
          slot="jt-form-slot-Application ID"
          style="border-style: solid; width: 400px; height: 250px; text-align: center; margin: auto; padding: 70px 0;">
          Place Card Here
          <br>
          (Passcard No: {{ pageApplicationPasscardNo }})
        </div>

      </div>

      <hr>

      <div 
        v-show="pageShowExtra"
        style="padding-left: 30px; padding-right: 30px">

        <img v-bind:src="imageHeader" style="width: 100%"/>

        <br>
        <br>
        <h3 style="text-align: center">PASSCARD RETURN ACKNOWLEDGEMENT</h3>
        <br>

        <div>
          This is to confirm that parking access card no <b>{{pageApplicationPasscardNo}}</b> belong to 
          {{pageApplicationCustomer}}
          <b>({{pageApplicationLicense}} - {{pageApplicationCarpark}})</b>
          <br>
          <br>
          <label class="form-control-static">Has Been Received By:</label>
          <table>
            <tr>
              <td><label class="form-control-static">Staff Name:</label></td>
              <td><label class="form-control-static"><b>{{pageApplicationStaffName}}</b></label></td>
            </tr>
            <tr>
              <td><label class="form-control-static">Staff No: </label></td>
              <td><label class="form-control-static"><b>{{pageApplicationStaffNo}}</b></label></td>
            </tr>
            <tr>
              <td><label class="form-control-static">Submission Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></td>
              <td><label class="form-control-static"><b>{{pageApplicationSubmissionDate}}</b></label></td>
            </tr>
            <tr>
              <td><label class="form-control-static">Form ID: </label></td>
              <td><label class="form-control-static"><b>{{pageApplicationNum}}</b></label></td>
            </tr>
          </table>
        </div>

        <br>
        <TemplateButton 
          v-show="pageShowAction && pageAction"
          type="button"
          class="btn btn-primary"
          v-on:click="onActionButtonClick">
          {{pageAction}}
        </TemplateButton>

      </div>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import loader from "@/components/Utility/Loader"

var querystring = require('querystring');

const PARAM = [
  {
    key: 'Application ID',
  },
  {
    key: 'Car Park Name',
  },
  {
    key: 'Parking License',
  },
  {
    key: 'Account Holder Name',
  },
  {
    key: 'Parker Name',
  },
  {
    key: 'Has Passcard Returned',
  },
  {
    key: 'Passcard No.',
  },
  {
    key: 'Phone No.',
  },
  {
    key: 'Status',
  },
  {
    key: 'Submission Date',
  },
  {
    form_section: 'STAFF INPUT INFORMATION',
  },
  {
    key: 'Staff Name',
  },
  {
    key: 'Staff No.',
  },
];
PARAM.forEach(k => {
  k['form_html'] = k['form_html'] || function(formInputParameter, formData) {
    return `<div class="row">
      <label class="control-label text-left col-md-3">${formInputParameter.key} :</label>
      <div class="col-md-9"><p class="form-control-static"><b>${formData[formInputParameter.key] || ' '}</b></p></div>
      </div>`;
      // the space is needed to pass DOM empty check
  }
});
const PARAM_MAP = helper.transformParamToMap(PARAM);


export default {
  name: "PagePasscardToParkaideForm",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'Passcard to ParkAide', url: '/passcardToParkAide' },
        { name: 'Application' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageTermination: null,
      pageLease: null,
      pageSeason: null,
      pageFees: {},
      pageParker: null,

      pageApplicationNum: '',
      pageApplicationPasscardNo: '',
      pageApplicationCustomer: '',
      pageApplicationLicense: '',
      pageApplicationCarpark: '',
      pageApplicationStaffName: '',
      pageApplicationStaffNo: '',
      pageApplicationSubmissionDate: '',
      pageShowData: false,
      pageShowExtra: false,
      pageAction: null,
      pageShowAction: true,

      imageHeader: '',
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/passcardToParkAide');
    });

    this.loadApplication();
  },
  methods: {
    loadApplication() {
      this.pageShowAction = this.$route.query.action;
      if(helper.hasEditPermission(this.permission)) {
        this.pageShowAction = this.pageShowAction;
      } else {
        this.pageShowAction = false;
      }
      
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {
        loader.loadData(
          this, 
          'passcard to ParkAide application info', 
          helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + applicationID + '&type1=passcardToParkAide', 
          null, 
          (data) => {
            if(data && data.length > 0) {
              this.pageLease = data;
              this.pageApplication = data[0];            
              this.loadInitial();
            }
          }
        )
      } else {
        this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
      }
    },
    async loadInitial() {
      if(await loader.loadInitial(this)) {
        this.loadCarParkRelated();
      }
    },
    async loadCarParkRelated() {
      if(await loader.loadCarparkRelated(this, this.pageApplication['carparkID'])) {
        this.loadCustomerRelated();
      }
    },
    async loadCustomerRelated() {
      if(await loader.loadCustomerRelated(this, this.pageApplication['customerID'])) {
        this.loadCarparkFinance();
      }
    },
    loadCarparkFinance() {
      let feedbackItem = 'car park detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageApplication['carparkID'] + '/finance/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageFinance = response.data[0];
            this.imageHeader = this.pageFinance.logoHeader1;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    async loadData() {
      this.loadLeaseData();
    },
    async loadLeaseData() {
      if(!await loader.loadLeaseRelated(this, this.pageLease)) {
        return;
      }

      let temp = {};
      this.pageApplicationNum = temp['Application ID'] = helper.plFormPTPANum(this.pageApplication['applicationID'], this.pageApplication['carparkID']);
      let carpark  = this.pageCarpark.find(k => helper.compareID(k.id, this.pageApplication['carparkID'])) || {};
      this.pageApplicationCarpark = temp['Car Park Name'] = carpark['name'];
      let season  = this.pageSeason.find(k => helper.compareID(k.id, this.pageApplication['seasonID'])) || {};
      temp['Car Park Product Name'] = season['name'];
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.pageApplication['licenseID'])) || {};
      temp['Parking License'] = helper.plFormPLNum(license['licenseOperatorNum'], license['carparkID']);
      let customer = this.pageCustomer.find(k => helper.compareID(k.id, this.pageApplication['customerID'])) || {};
      temp['Account Holder Name'] = customer['name'];
      let parker = this.pageParker.find(k => helper.compareID(k.id, this.pageApplication['parkerID'])) || {};
      temp['Parker Name'] = parker['name'];
      temp['Has Passcard Returned'] = 'Yes';
      let passcard = this.pagePasscard.find(k => helper.compareID(k.id, this.pageApplication['passcardID'])) || {};
      let passtype = this.pagePasstype.find(k => helper.compareID(k.id, passcard['passtypeID'])) || {};
      temp['Passcard Type'] = passtype['name'];
      this.pageApplicationPasscardNo = temp['Passcard No.'] = passcard['sku'];
      this.pageApplicationCustomer = customer['name'];
      this.pageApplicationLicense = temp['Parking License'];
      temp['Status'] = this.pageApplication['status1'];
      temp['Phone No.'] = this.pageApplication['data2'];
      this.pageApplicationSubmissionDate = temp['Submission Date'] = helper.formatDate(this.pageApplication['createDate']);
      let staff = this.pageStaff.find(k => helper.compareID(k.id, this.pageApplication['data4'])) || {};
      this.pageApplicationStaffName = temp['Staff Name'] = staff['name'];
      this.pageApplicationStaffNo = temp['Staff No.'] = staff['personnelCode'];

      this.pageShowExtra = true;

      if(this.pageApplication['status1'] === 'Approved') {
        this.pageAction = 'Mark as Inventory In Stock';
      }

      this.$refs['pageForm'].setForm(false, temp);
      this.pageShowData = true;
    },
    
    onPrintButtonClick() {
      window.print();
    },
    async onActionButtonClick() {
      let feedbackItem = 'passcard status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      let result = await this.$http
        .put(
          helper.SERVER_URL + '/api2/passcard/' + this.pageApplication['passcardID'],
            querystring.stringify({
              movement: 'In Stock',
              carparkID: this.pageApplication['carparkID'],
            }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        });

      if(result) {
        feedbackItem = 'passcard to ParkAide appplication status';
        this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
        this.$http
          .put(
            helper.SERVER_URL + '/api2/request/' + this.pageApplication['id'],
            querystring.stringify({
              status1: 'Completed',
              date1: new Date().getTime() / 1000,
            }),
            helper.createAxiosFormConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            if(this.$route.query.action) {
              helper.redirect({ path: helper.WEB_URL + '/passcardReturnToParkAide', query: { carparkID: this.pageApplication['carparkID'], licenseID: this.pageApplication['licenseID'] }});
            } else {
              helper.redirect({ path: helper.WEB_URL + '/passcardToParkAide', query: { carparkID: this.pageApplication['carparkID'], licenseID: this.pageApplication['licenseID'] }});
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
          })
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscardToParkAideForm.vue